import(/* webpackMode: "eager" */ "/var/www/SOC/app/[lang]/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Cairo\",\"arguments\":[{\"subsets\":[\"latin\",\"arabic\"],\"variable\":\"--font-cairo\"}],\"variableName\":\"cairo\"}");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-primary\"}],\"variableName\":\"primary\"}");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Rajdhani\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-secondary\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"secondary\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/var/www/SOC/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/public/assets/images/brand/SocLogoEN.webp");
;
import(/* webpackMode: "eager", webpackExports: ["LangToggle"] */ "/var/www/SOC/src/components/lang-toggle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/var/www/SOC/src/components/mode-toggle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/SOC/src/components/theme-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/SOC/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/var/www/SOC/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandLogo"] */ "/var/www/SOC/src/layout/brand-logo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/var/www/SOC/src/layout/footer/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/SOC/src/layout/header/desktop/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/SOC/src/recoil/RecoilProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AOSInit"] */ "/var/www/SOC/src/utils/aos/index.tsx");
